import { EnvironmentUtils, UserUtils } from 'utils'
import { AccountTypes } from 'modules/Auth/types'

class PermissionUtils {
  searchDenied() {
    const { trainingAdministratorEnabled, competenceManagerEnabled } =
      EnvironmentUtils.getPermissions('general')
    return !trainingAdministratorEnabled && !competenceManagerEnabled
  }

  libraryDenied() {
    const { trainingAdministratorEnabled } = EnvironmentUtils.getPermissions('general')
    const { allowToSeeOceanLibrary } = EnvironmentUtils.getPermissions('elearnings')
    return !trainingAdministratorEnabled || !allowToSeeOceanLibrary
  }

  cesDenied() {
    const { cesEnabled } = EnvironmentUtils.getPermissions('general')
    const searchDenied = this.searchDenied()
    return searchDenied && !cesEnabled
  }

  virtualClassroomDenied() {
    const { virtualClassroomEnabled } = EnvironmentUtils.getPermissions('general')
    return !virtualClassroomEnabled
  }

  virtualClassroomMenuDenied() {
    const { type } = UserUtils.getUserAccountInfo()
    const isSpecialUser = type === AccountTypes.SpecialUser
    const { virtualClassroomEnabled } = EnvironmentUtils.getPermissions('general')
    return !virtualClassroomEnabled || isSpecialUser
  }

  requirementsDenied() {
    const user = UserUtils.getUserAccountInfo()
    return user.type === AccountTypes.SpecialUser || this.searchDenied()
  }

  assessmentPlayerDenied() {
    const user = UserUtils.getUserAccountInfo()
    return user.type === AccountTypes.SpecialUser
  }

  adaptiveContentPlayerDenied() {
    const user = UserUtils.getUserAccountInfo()
    return user.type === AccountTypes.SpecialUser
  }

  profileProgressDenied() {
    return this.libraryDenied()
  }

  simulatorTrainingDenied() {
    const { isSimulatorTrainingInstructorLedEnabled, isSimulatorTrainingStudentLedEnabled } =
      EnvironmentUtils.getPermissions('general')
    return !isSimulatorTrainingInstructorLedEnabled && !isSimulatorTrainingStudentLedEnabled
  }

  simulatorTrainingInstructorLedMenuDenied() {
    const { isSimulatorTrainingInstructorLedEnabled } = EnvironmentUtils.getPermissions('general')
    const { instructorLedAvailable } = EnvironmentUtils.getPermissions('simulatorTraining')
    return !isSimulatorTrainingInstructorLedEnabled || !instructorLedAvailable
  }

  simulatorTrainingStudentLedMenuDenied() {
    const { isSimulatorTrainingStudentLedEnabled } = EnvironmentUtils.getPermissions('general')
    const { studentLedAvailable } = EnvironmentUtils.getPermissions('simulatorTraining')
    return !isSimulatorTrainingStudentLedEnabled || !studentLedAvailable
  }

  // OLPFE-1407 UI - do not check 'simulatortraining' permission for students' releated views
  simulatorTrainingInstructorLedDenied() {
    const { type } = UserUtils.getUserAccountInfo()
    const isSpecialUser = type === AccountTypes.SpecialUser
    const { isSimulatorTrainingInstructorLedEnabled } = EnvironmentUtils.getPermissions('general')
    const { instructorLedAvailable } = EnvironmentUtils.getPermissions('simulatorTraining')
    // Skip simulatorTraining permisstions for student routes
    return !isSimulatorTrainingInstructorLedEnabled || (isSpecialUser && !instructorLedAvailable)
  }

  // OLPFE-1407 UI - do not check 'simulatortraining' permission for students' releated views
  simulatorTrainingStudentLedDenied() {
    const { type } = UserUtils.getUserAccountInfo()
    const isSpecialUser = type === AccountTypes.SpecialUser
    const { isSimulatorTrainingStudentLedEnabled } = EnvironmentUtils.getPermissions('general')
    const { studentLedAvailable } = EnvironmentUtils.getPermissions('simulatorTraining')
    // Skip simulatorTraining permisstions for student routes
    return !isSimulatorTrainingStudentLedEnabled || (isSpecialUser && !studentLedAvailable)
  }

  virtualClassroomManageEventsDenied() {
    const { virtualEventAdministratorAvailable } = EnvironmentUtils.getPermissions('virtualEvent')
    return !virtualEventAdministratorAvailable
  }

  selfServiceConfigurationDenied() {
    const { type } = UserUtils.getUserAccountInfo()
    const isSpecialUser = type === AccountTypes.SpecialUser
    const { trainingMatrixAvailable, programBuilderAvailable } = EnvironmentUtils.getPermissions(
      'selfServiceConfiguration'
    )
    return !isSpecialUser || (!trainingMatrixAvailable && !programBuilderAvailable)
  }

  dashboardDenied() {
    const { type } = UserUtils.getUserAccountInfo()
    return type !== AccountTypes.SpecialUser
  }

  assessmentPlatformDenied() {
    const { type } = UserUtils.getUserAccountInfo()
    const isSpecialUser = type === AccountTypes.SpecialUser
    const { oceanAssessmentPlatformAvailable } =
      EnvironmentUtils.getPermissions('oceanAssessmentPlatform')
    return !isSpecialUser || !oceanAssessmentPlatformAvailable
  }

  programDenied() {
    const { type } = UserUtils.getUserAccountInfo()
    return type === AccountTypes.SpecialUser
  }
}

const permissionUtils = new PermissionUtils()

export default permissionUtils
